import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import style from './styles.module.scss';

export default function Text({
  className = null,
  children = null,
  bold = null,
  thin = null,
  meta = null,
  secondary = null,
  isError = false,
  size = 18,
  hoverable = null,
  inline = null,
  ml = 0,
  mr = 0,
  mb = 0,
  mt = 0,
  onClick = () => null,
  styles,
  width = undefined,
}) {
  return (
    <div
      onClick={onClick}
      style={{
        fontSize: size,
        marginRight: mr,
        marginLeft: ml,
        marginTop: mt,
        marginBottom: mb,
        minWidth: width,
        ...styles,
      }}
      className={classNames(
        style.standard,
        className,
        { [style.inline]: inline },
        { [style.hoverable]: hoverable },
        { [style.meta]: meta },
        { [style.bold]: bold },
        { [style.thin]: thin },
        { [style.secondary]: secondary },
        { [style.error]: isError },
        { [style[size]]: size },
      )}
    >
      {children}
    </div>
  );
}
Text.propTypes = {
  size: PropTypes.number,
  bold: PropTypes.bool,
  thin: PropTypes.bool,
  meta: PropTypes.bool,
  secondary: PropTypes.bool,
  isError: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  hoverable: PropTypes.bool,
  inline: PropTypes.bool,
  mr: PropTypes.number,
  ml: PropTypes.number,
  mb: PropTypes.number,
  mt: PropTypes.number,
  onClick: PropTypes.func,
  width: PropTypes.number,
};
